import { LOCALES, LOCALE_LABEL_KEY, useLanguage, type Locale } from "./LanguageProvider.js";

/**
 * Language choice, as a small set of buttons rather than a select: two options
 * on a shared screen or a phone are quicker to hit than a dropdown.
 */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale, t } = useLanguage();

  return (
    <div
      className={`language-switcher${compact ? " is-compact" : ""}`}
      role="group"
      aria-label={t("common.language")}
    >
      {LOCALES.map((option: Locale) => (
        <button
          key={option}
          type="button"
          onClick={() => setLocale(option)}
          aria-pressed={locale === option}
          className={`language-switcher-option${locale === option ? " is-active" : ""}`}
        >
          {t(LOCALE_LABEL_KEY[option])}
        </button>
      ))}
    </div>
  );
}
